<template>
    <footer class="footer">

        <!--Top footer-->
        <div class="footerTop">
            <v-row class="d-flex align-center justify-center footerRow">

                <!--Nous joindre - gauche-->
                <v-col cols="12" md="4" class="footerCol">
                    <h3 class="footerTitle">Nous joindre</h3>
                    <ul class="footerContact">
                        <li>
                            <img class="footerIcon" src="/Resources/images/icon/location.png"/>
                            <span>{{ $t('footer.address') }}</span>
                        </li>
                        <li>
                            <img class="footerIcon" src="/Resources/images/icon/phone.png"/>
                            <a class="footerContactLink" href="tel:819-472-7904" v-html="$t('footer.phone')"></a>
                        </li>
                        <li>
                            <img class="footerIcon" src="/Resources/images/icon/mail.png"/>
                            <a class="footerContactLink" href="/cdn-cgi/l/email-protection#d5bcbbb3ba95b7bca6a6babba6b0a7a3bcb6b0fbb6bab8" v-html="$t('footer.email')"></a>
                        </li>
                        <li>
                            <img class="footerIcon" src="/Resources/images/sm/facebook-25x25.svg" style="filter:brightness(0.7);"/>
                            <a class="footerContactLink" href="https://www.facebook.com/BissonService" target="_blank">Facebook</a>
                        </li>
                    </ul>
                </v-col>

                <!--Logo - centre-->
                <v-col cols="12" md="4" class="footerCol d-flex flex-column align-center txt-c">
                    <div ref="logoBisson" id="logo" class="scroll-textes" :class="{ 'is-visible': campaignLogoBisson }">
                        <img class="footerLogo" src="/Resources/images/logo/logoFooter.png"/>
                        <p class="footerSlogan">La solution pour une eau de qualité depuis 1958</p>
                    </div>
                </v-col>

                <!--Heures d'ouverture - droite-->
                <v-col cols="12" md="4" class="footerCol footerColRight">
                    <h3 class="footerTitle">Heures d'ouverture</h3>
                    <ul class="footerHours">
                        <li><span class="footerHoursDay">{{ $t('footer.mondayToFriday') }}</span></li>
                        <li><span class="footerHoursDay">{{ $t('footer.saturday') }}</span></li>
                        <li><span class="footerHoursDay">{{ $t('footer.sunday') }}</span></li>
                    </ul>
                    <div class="footerEmergency">
                        <span class="footerEmergencyLabel">Urgence 24h :</span>
                        <a class="footerPhone" href="tel:819-472-7904">1 819 472-7904</a>
                    </div>
                </v-col>

            </v-row>
        </div>

        <!--Bottom bar-->
        <div class="footerBottom">
            <div class="footerBottomLeft">
                <span>{{ $t('footer.Licence') }}</span>
                <span class="footerDivider">|</span>
                <span @click="openCookie()" class="footerBottomLink">Mes témoins</span>
                <span class="footerDivider">|</span>
                <span @click="navigateToPolicy()" class="footerBottomLink">Politique de confidentialité</span>
            </div>
            <div class="footerBottomRight">
                <span>© {{ currentYear }} Bisson Service. Tous droits réservés.</span>
            </div>
        </div>

    </footer>
</template>

<style scoped>
    /*#region Footer global*/
    .footer {
        background-color: rgb(var(--secondary));
        color: rgba(255,255,255,0.85);
        margin: 0; padding: 0;
    }
    .footerTop { padding: 60px 80px 40px 80px; }
    .footerRow { gap: 0; }
    .footerCol { padding: 0 30px 30px 30px; }
    /*#endregion*/

    /*#region Logo*/
    .footerLogo { height: 90px; width: auto; margin-bottom: 16px; }
    .footerSlogan { font-size: 13px; color: rgba(255,255,255,0.65); font-style: italic; line-height: 1.5; max-width: 200px; margin: 0 auto; }
    /*#endregion*/

    /*#region Titles*/
    .footerTitle {
        color: #ffffff;
        font-size: 14px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1.5px;
        margin-bottom: 18px;
        padding-bottom: 10px;
        border-bottom: 2px solid rgb(var(--primary));
        display: inline-block;
    }
    /*#endregion*/

    /*#region Navigation links*/
    .footerLinks { list-style: none; padding: 0; margin: 0; }
    .footerLinks li { margin-bottom: 10px; }
    .footerLinks a {
        color: rgba(255,255,255,0.75);
        text-decoration: none;
        font-size: 14px;
        transition: color 0.2s, padding-left 0.2s;
        display: inline-block;
    }
    .footerLinks a:hover { color: #ffffff; padding-left: 6px; }
    /*#endregion*/

    /*#region Heures*/
    .footerHours { list-style: none; padding: 0; margin: 0 0 16px 0; }
    .footerHours li { margin-bottom: 8px; }
    .footerHoursDay { font-size: 14px; color: rgba(255,255,255,0.75); }
    .footerEmergency { margin-top: 16px; padding: 8px 12px; background-color: rgba(var(--primary), 0.15); border-right: 3px solid rgb(var(--primary)); border-radius: 4px 0 0 4px; display: inline-block; text-align: right; }
    .footerEmergencyLabel { font-size: 12px; color: rgba(255,255,255,0.75); display: block; margin-bottom: 2px; }
    .footerPhone { color: #ffffff; font-weight: 600; font-size: 14px; text-decoration: none; }
    .footerPhone:hover { text-decoration: underline; }
    /*#endregion*/

    /*#region Coordonnées*/
    .footerContact { list-style: none; padding: 0; margin: 0; }
    .footerContact li { display: flex; align-items: flex-start; gap: 10px; margin-bottom: 12px; font-size: 14px; color: rgba(255,255,255,0.75); }
    .footerIcon { height: 14px; width: 14px; margin-top: 3px; flex-shrink: 0; filter: brightness(0.7); }
    .footerContactLink { color: rgba(255,255,255,0.75); text-decoration: none; transition: color 0.2s; }
    .footerContactLink:hover { color: #ffffff; }
    /*#endregion*/

    .footerColRight { text-align: right; }
    .footerColRight .footerTitle { }
    .footerColRight .footerHours { }
    .footerColRight .footerEmergency { margin-left: auto; text-align: right; }
    .footerColRight .footerEmergencyLabel { text-align: right; }
    .footerBottom {
        border-top: 1px solid rgba(255,255,255,0.1);
        padding: 16px 80px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
        gap: 10px;
        font-size: 12px;
        color: rgba(255,255,255,0.5);
    }
    .footerBottomLeft { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
    .footerDivider { opacity: 0.4; }
    .footerBottomLink { cursor: pointer; transition: color 0.2s; }
    .footerBottomLink:hover { color: rgba(255,255,255,0.9); text-decoration: underline; }
    .footerBottomRight { }
    /*#endregion*/

    /*#region Scroll animation*/
    .scroll-textes { opacity: 0; transform: translateY(20px); transition: opacity 0.8s ease, transform 0.8s ease; }
    .scroll-textes.is-visible { opacity: 1; transform: translateY(0); }
    /*#endregion*/

    @media handheld, only screen and (max-width: 600px) {
        .footerTop { padding: 30px 20px 20px 20px; }
        .footerCol { padding: 0 10px 25px 10px; }
        .footerBottom { padding: 14px 20px; flex-direction: column; align-items: flex-start; }
        .footerLogo { height: 70px; }
    }
    @media handheld, only screen and (max-width: 960px) {
        .footerTop { padding: 40px 30px 20px 30px; }
        .footerCol { padding: 0 15px 25px 15px; }
        .footerBottom { padding: 14px 30px; }
        .footerLogo { height: 75px; }
    }
    @media handheld, only screen and (max-width: 1279px) {
        .footerTop { padding: 50px 40px 30px 40px; }
        .footerBottom { padding: 14px 40px; }
    }
</style>

<script>
    import translations from '../../public/Resources/i18N/global.json';

    export default {
        name: 'Footer',
        data: () => ({
            campaignLogoBisson: false,
        }),
        computed: {
            currentYear() { return new Date().getFullYear(); }
        },
        async mounted() {
            this.$i18n.mergeLocaleMessage('fr', translations.fr);
            this.$i18n.mergeLocaleMessage('en', translations.en);
            await this.createObserverFooter();
        },
        methods: {
            navigateToPolicy() { this.$router.push('/PolitiqueDeConfidentialiter'); },
            openCookie() { $App.event.$emit('openCookie'); },
            async createObserverFooter() {
                const options = { threshold: 0.3 };
                const observer = new IntersectionObserver((entries) => {
                    entries.forEach(entry => {
                        if (entry.target.id === 'logo') {
                            this.campaignLogoBisson = entry.isIntersecting;
                        }
                    });
                }, options);
                if (this.$refs.logoBisson) observer.observe(this.$refs.logoBisson);
            },
        },
        component: {}
    }
</script>